import React, { useState, useEffect } from "react";
import "../Render/June2026/RenderSettingsStyle.css";
import { BiRightArrow } from "react-icons/bi";
import { LuSettings } from "react-icons/lu";
import "./RendersStyle.css";
import { AiOutlineClockCircle } from "react-icons/ai";

import Dropdown_render from "../../../Components/Dropdown/Dropdown_render";
import { Checkbox } from "../../../Components";

import { useDispatch, useSelector } from "react-redux";
import {
  saveProjectSettings,
  updateSettingOptionState,
} from "../../../Redux/actions/projectActions";
import { getAspectRatio } from "./render.constants";
import { speedDropdownOptions } from "./scrollSpeedMap";
import { ASPECT_FRAME_OPTIONS } from "../Preview/previewPlaybackUtils";

const RenderSettings = (props) => {
  const dispatch = useDispatch();
  // console.log('Render Settings Props => ', props);
  const {
    // isCard,
    resolution,
    aspectFrame,
    onAspectFrameChange,
    // aspectRatio,
    IsUpgradeOpen,
    isUserPaid,
    paideRenderSettingsOptions,
    freeRenderSettingsOptions,
   
    handleResolutionChange,
    paideRenderFormats,
    freeRenderFormats,
    formats,
    handleFormatChange,
    paidFramRate,
    freeFramRate,
    fps,
    setFps,
    speed,
    setSpeed,
    min,
    sec,
    isEmailSend,
    setIsEmailSend,
   
    handleScrollRenderExport,
    handleCardRenderExport,
  } = props;

  const project = useSelector((state) => state?.project || {});
  // console.log('Render Settings REDUX Project Data => ',project);
  const { _id, isCard } = useSelector((state) => state?.project || {});
  const  cardresolution = useSelector((state) => state?.project?.resolution || {});
  const { videoWidth, videoHeight } = cardresolution;
  const aspectRatio = getAspectRatio(videoWidth, videoHeight);

  const resolutionOptions = isUserPaid ? paideRenderSettingsOptions : freeRenderSettingsOptions;
  const formatOptions = isUserPaid ? paideRenderFormats : freeRenderFormats;
  const fpsOptions = isUserPaid ? paidFramRate : freeFramRate;
  const projectSettings = project?.settings ?? {};
  const endHoldEnabled = Boolean(projectSettings?.end_hold_enabled);

  const handleEndHoldChange = (nextEnabled) => {
    const nextSettings = {
      ...projectSettings,
      end_hold_enabled: Boolean(nextEnabled),
    };
    dispatch(updateSettingOptionState("end_hold_enabled", Boolean(nextEnabled)));
    dispatch(saveProjectSettings(nextSettings));
  };

  return (
    <div className="w-full h-full bg-[rgba(255,255,255,.02)] border-[rgba(255,255,255,.06)] rounded-2xl relative renderpage-SettingContainer">
      <div className="flex gap-2">
        <div className="w-full mt-8 flex flex-col sm:flex-row justify-between gap-4 border-[rgba(255,255,255,.06)] pt-6">
          <div className="flex items-center renderpage-titleBox">
            <LuSettings className="text-[#c4b2ff]" size={25} />
            <h1 className="renderpage-title">Render Settings </h1>
          </div>
          <div className="flex items-center mb-6" />
        </div>
      </div>

      <div
        className={
          "grid grid-cols-1 sm:grid-cols-2 gap-5 " +
          (isCard ? "lg:grid-cols-5" : "lg:grid-cols-6")
        }
      >
        {!isCard && (
          <div className="space-y-1 rs-field">
            <label className="rs-DD-label uppercase">
              <span className="text-[#625e83]">Aspect Ratio</span>
            </label>
            <Dropdown_render
              isUserPaid={true}
              options={ASPECT_FRAME_OPTIONS}
              value={aspectFrame}
              onChange={(value) => onAspectFrameChange?.(value)}
            />
          </div>
        )}

        {/* Resolution — dropdown for scroll, display for card */}
        <div className="space-y-1 rs-field">
          <label className="rs-DD-label uppercase">
            <span className="text-[#625e83]">Resolution</span>
          </label>

          {isCard ? (
            <div className="custom-displaypanel">
              <span className="mr-1">{videoWidth}X{videoHeight}</span>
            </div>
          ) : (
            <Dropdown_render
              isUserPaid={isUserPaid}
              options={resolutionOptions || []}
              value={`${resolution}`}
              onChange={(value) => {
                isUserPaid && handleResolutionChange?.(value);
              }}
              IsUpgradeOpen={IsUpgradeOpen}
            />
          )}
        </div>

        {/* Aspect Ratio (card) / Format (scroll) */}
        <div className="space-y-1 rs-field">
          <label className="rs-DD-label uppercase">
            <span className="text-[#625e83]">
              {isCard ? "Aspect Ratio" : "Format"}
            </span>
          </label>

          {isCard ? (
            <div className="custom-displaypanel">
              <span className="mr-1">{aspectRatio}</span>
            </div>
          ) : (
            <Dropdown_render
              isUserPaid={isUserPaid}
              options={formatOptions || []}
              value={formats}
              onChange={(value) => {
                isUserPaid && handleFormatChange?.(value);
              }}
              IsUpgradeOpen={IsUpgradeOpen}
            />
          )}
        </div>

        {/* Format (card) / Frame Rate (scroll) */}
        <div className="space-y-1 rs-field">
          <label className="uppercase rs-DD-label">
            <span className="text-[#625e83]">
              {isCard ? "Format" : "Frame Rate"}
            </span>
          </label>

          {isCard ? (
            <Dropdown_render
              isUserPaid={isUserPaid}
              options={formatOptions || []}
              value={formats}
              onChange={(value) => {
                isUserPaid && handleFormatChange?.(value);
              }}
              IsUpgradeOpen={IsUpgradeOpen}
            />
          ) : (
            <Dropdown_render
              isUserPaid={isUserPaid}
              options={fpsOptions || []}
              value={fps}
              onChange={setFps}
              IsUpgradeOpen={IsUpgradeOpen}
            />
          )}
        </div>

        {/* Frame Rate (card) / Speed (scroll) */}
        <div className="space-y-1 rs-field">
          <label className="uppercase rs-DD-label">
            <span className="text-[#625e83]">
              {isCard ? "Frame Rate" : "Speed"}
            </span>
          </label>

          {isCard ? (
            <Dropdown_render
              isUserPaid={isUserPaid}
              options={fpsOptions || []}
              value={fps}
              onChange={setFps}
              IsUpgradeOpen={IsUpgradeOpen}
            />
          ) : (
            <Dropdown_render
              isUserPaid={true}
              options={speedDropdownOptions}
              value={speed}
              onChange={(value) => setSpeed?.(Number(value))}
            />
          )}
        </div>

        {/* Running Time — always display */}
        <div className="space-y-1 rs-field flex flex-col justify-between">
          <label className="rs-DD-label uppercase">
            <span className="text-[#625e83] text-start">Running Time</span>
          </label>

          <div className="custom-displaypanel">
            <AiOutlineClockCircle />
            <span className="mr-1">
              {String(min).padStart(2, "0")}
              <span>{" :"}</span>
            </span>
            <span>{String(sec).padStart(2, "0")}</span>
          </div>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row justify-between border-t border-[rgba(255,255,255,.06)] rendersetting-ftr-section">
        <div className="render-setting-options">
          <div className="flex items-center cursor-pointer text-[#625e83] hover:text-white transition-colors notifyEmailText">
            <Checkbox isEmailSend={isEmailSend} setIsEmailSend={setIsEmailSend} />
            Email me when render is complete
          </div>

          {!isCard && (
            <div className="render-end-behavior-option notifyEmailText">
              <Checkbox
                label="Hold last block at center"
                checked={endHoldEnabled}
                onChange={handleEndHoldChange}
                ariaLabel="Hold last block at center"
              />
            </div>
          )}
        </div>

        <div>
          {isCard && (
            <button
              className="rnder-exportBtn"
              onClick={handleCardRenderExport}
            >
              <BiRightArrow size={20} /> Start Render
            </button>
          )}
          {!isCard && (
            <button
              className="rnder-exportBtn"
              onClick={handleScrollRenderExport}
            >
              <BiRightArrow size={20} /> Start Render
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default RenderSettings;
